import { useQuery } from 'react-query';
import { createAssortmentStatisticsKey } from 'constants/queryCacheKeys';
import { getAssortmentStatistics, TAssortmentStatisticsParams } from 'domain/products';

export const useAssortmentStatistics = (params: TAssortmentStatisticsParams) => {
  return useQuery(createAssortmentStatisticsKey(params), () => getAssortmentStatistics(params));
};
